import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";
import { UpdateDeliveryLocationBody } from "./updateDeliveryLocation.types";

export const requestCreateDeliveryLocation = async (
  body: UpdateDeliveryLocationBody
): Promise<void> => {
  const getUrl = () => {
    if (body.existingCountryName && body.newCountryName) {
      return buildUrl(ApiRoutesDeliveryFees.DeliveryLocationCountry);
    }

    if (body.existingCityName && body.newCityName) {
      return buildUrl(ApiRoutesDeliveryFees.DeliveryLocationCity);
    }

    return buildUrl(ApiRoutesDeliveryFees.DeliveryLocationArea);
  };

  return await instance.patch(getUrl(), body);
};
